import { ExclusiveChoiceDropdown, SingleLineTextInput } from "dash-styled"
import React, { ChangeEvent, FC, useEffect, useState } from "react"
import { useDebounce } from "../../../../../../Hooks/useDebounce"
import { FeedbackMessageFilter } from "../../../../../../Models/API/JobModel"
import { PredicateInputComponentProps } from "../../../../../Common/FilterComposer/FilterPredicate"

export function FeedbackMessageInput(): FC<
    PredicateInputComponentProps<FeedbackMessageFilter>
> {
    const Input: FC<PredicateInputComponentProps<FeedbackMessageFilter>> = ({
        value,
        onChange
    }) => {
        const [immediateValue, setImmediateValue] = useState<string>(
            value.feedbackSearch ?? ""
        )
        const debouncedValue = useDebounce(immediateValue, 500)
        const handleChange = (e: ChangeEvent<HTMLInputElement>) =>
            setImmediateValue(e.target.value)

        useEffect(
            () => {
                onChange({ feedbackSearch: debouncedValue })
            },
            // eslint-disable-next-line react-hooks/exhaustive-deps
            [debouncedValue]
        )

        return (
            <SingleLineTextInput
                className="flex-grow"
                testId="feedback-search-value"
                autoComplete="off"
                size="sm"
                type="text"
                transparentBg={true}
                value={immediateValue}
                onChange={handleChange}
            />
        )
    }
    return Input
}

export function FeedbackMessageTagInput(
    choices: { [label: string]: number },
    isSame = (a: number, b: number) => a === b
): FC<PredicateInputComponentProps<FeedbackMessageFilter>> {
    const [values, labels]: [number[], string[]] = Object.entries(
        choices
    ).reduce(
        ([passedValues, passedLabels], [l, v]) => [
            passedValues.concat([v]),
            passedLabels.concat([l])
        ],
        [[], []] as [number[], string[]]
    )

    const SingleInput: FC<PredicateInputComponentProps<FeedbackMessageFilter>> =
        ({ value, onChange }) => {
            const handleChange = (index: number) =>
                onChange({ feedbackTags: values[index] })

            return (
                <ExclusiveChoiceDropdown
                    className="flex-grow"
                    testId="feedback-tags-value"
                    choices={labels}
                    selectedIndex={values.findIndex(v =>
                        isSame(v, value.feedbackTags ?? -1)
                    )}
                    onClick={handleChange}
                    size="sm"
                />
            )
        }

    return SingleInput
}
